import { retry } from "@reduxjs/toolkit/query";
import React, { useEffect, useState } from "react";
import InputAHSF from "../../../../Components/InputAHSF";
import { useDispatch, useSelector } from "react-redux";
import {
  AddSU_NT_MRI_PublishedSientific,
  GetOneSU_NT_MRI_PublishedSientificResearch,
  UpdateSU_NT_MRI_PublishedSientific,
} from "../../../../Redux/Reducers/Submitter/PublishedScientificRes";
import ButtonAHSF from "../../../../Components/ButtonAHSF";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../../../Services/Encryption/EncryptionParams";
import $ from "jquery";
import Swal from "sweetalert2";
import { setRefreshTable } from "../../../../Redux/Reducers/Shared/VariousVariables";
import {
  AddSU_NT_MRI_AcademicQualifications,
  GetOneSU_NT_MRI_AcademicQualifications,
  UpdateSU_NT_MRI_AcademicQualifications,
} from "../../../../Redux/Reducers/Submitter/AcademicQualificationsDegree";
import { GetAllAcademicDegree } from "../../../../Redux/Reducers/Submitter/InformationAboutResearchers/AcademicDegreeDropdown";
import AllDropDownsAHSF from "../../../../Components/AllDropDownsAHSF";
import { GetAllSU_ST_MRI_Nationality } from "../../../../Redux/Reducers/Submitter/MainResearcherInformation/DropDown";

const AddEditeAcademic = (props) => {
  const dispatch = useDispatch();
  const AppGuid = useParams();
  const [validatenationalityId, setvalidatenationalityId] = useState(false);
  const [validateuniversity, setvalidateuniversity] = useState(false);
  const [validatemajor, setvalidatemajor] = useState(false);
  const [validategraduationYear, setvalidategraduationYear] = useState(false);
  const [validateacademicDegreeId, setvalidateacademicDegreeId] =
    useState(false);
  const state = useSelector((state) => {
    return {
      ApplicationInformation:
        state.ApplicationInformationReducer.ApplicationInformation,
      jsonData: state.FetchDataJson.JsonData,
      academicQualifications:
        state.AcademicQualificationsDegree.academicQualifications,
      loadingacademicQualifications:
        state.AcademicQualificationsDegree.loadingacademicQualifications,
      DropDownAcademicDegree:
        state.DropDownAcademicDegree.DropDownAcademicDegree,
      DropDownNationality: state.DropDown.DropDownNationality,
    };
  });
  const [list, setList] = useState({
    academicQualificationsId: null,
    academicDegreeId: null,
    graduationYear: null,
    major: null,
    university: null,
    nationalityId: null,
    applicationInformationId:
      localStorage.getItem("ApplicationInformationId") ||
      decryptToken(AppGuid.AppGuid),
  });
  const [show, setShow] = useState(false);
    const [editValue, setEditValue] = useState(null);
    const [editText, setEditText] = useState(null);
  const addAcademic = async () => {
    if (
      list.academicDegreeId != "" &&
      list.academicDegreeId != null &&
      list.graduationYear != "" &&
      list.graduationYear != null &&
      list.nationalityId != "" &&
      list.nationalityId != null &&
      list.major != "" &&
      list.major != null &&
      list.university != "" &&
      list.university != null
    ) {
      const add = await dispatch(
        AddSU_NT_MRI_AcademicQualifications({
          academicDegreeId: list.academicDegreeId,
          graduationYear: parseInt(list.graduationYear),
          major: list.major,
          university: list.university,
          nationalityId: list.nationalityId,
          applicationInformationId:
            localStorage.getItem("ApplicationInformationId") ||
            decryptToken(AppGuid.AppGuid),
        })
      );

      if (add.payload) {
        $(".close-btn").trigger("click");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "تم اضافة المعلومات بنجاح", // "Information updated successfully"
          showConfirmButton: false,
          timer: 1500, // Display success message for 1.5 seconds.
        });

        // Refresh the table by dispatching the action to update the table data.
        dispatch(setRefreshTable());
      }
    } else {
      if (list.major == "" || list.major == null) {
        setvalidatemajor(true);
      }
      if (list.nationalityId == "" || list.nationalityId == null) {
        setvalidatenationalityId(true);
      }
      if (list.university == "" || list.university == null) {
        setvalidateuniversity(true);
      }
      if (list.graduationYear == "" || list.graduationYear == null) {
        setvalidategraduationYear(true);
      }
      if (list.academicDegreeId == "" || list.academicDegreeId == null) {
        setvalidateacademicDegreeId(true);
      }
    }
  };

  const updateAcademic = async () => {
    console.log(list.graduationYear, "fghgfgfghfghf");

    if (
      list.academicDegreeId != "" &&
      list.academicDegreeId != null &&
      list.graduationYear != "" &&
      list.graduationYear != null &&
      list.nationalityId != "" &&
      list.nationalityId != null &&
      list.major != "" &&
      list.major != null &&
      list.university != "" &&
      list.university != null
    ) {
      const update = await dispatch(
        UpdateSU_NT_MRI_AcademicQualifications({
          academicQualificationsId: list.academicQualificationsId,
          academicDegreeId: list.academicDegreeId,
          graduationYear: parseInt(list.graduationYear),
          major: list.major,
          university: list.university,
          nationalityId: list.nationalityId,
          applicationInformationId: list.applicationInformationId,
        })
      );

      if (update.payload) {
        $(".close-btn").trigger("click");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "تم تعديل المعلومات بنجاح", // "Information updated successfully"
          showConfirmButton: false,
          timer: 1500, // Display success message for 1.5 seconds.
        });

        // Refresh the table by dispatching the action to update the table data.
        dispatch(setRefreshTable());
      }
    } else {
      if (list.major == "" || list.major == null) {
        setvalidatemajor(true);
      }
      if (list.nationalityId == "" || list.nationalityId == null) {
        setvalidatenationalityId(true);
      }
      if (list.university == "" || list.university == null) {
        setvalidateuniversity(true);
      }
      if (list.graduationYear == "" || list.graduationYear == null) {
        setvalidategraduationYear(true);
      }
      if (list.academicDegreeId == "" || list.academicDegreeId == null) {
        setvalidateacademicDegreeId(true);
      }
    }
  };

  const getData = async () => {
    if (props.canEdit) {
      const data = await dispatch(
        GetOneSU_NT_MRI_AcademicQualifications(props.academicQualificationsId)
      );

      if (data.payload) {
        setList({ ...data.payload });
        setShow(true);
      }
    } else {
      setShow(true);
    }
  };
  useEffect(() => {
    getData();
    dispatch(GetAllAcademicDegree());
    dispatch(GetAllSU_ST_MRI_Nationality());
  }, []);

  console.log(list.nationalityId, "natonality");

  console.log(state.DropDownAcademicDegree, "state.DropDownAcademicDegree");

  return !state.loadingacademicQualifications && show ? (
    <>
      <div className="AddEdite">
        <AllDropDownsAHSF
          fieldsName="AcademicDegree"
          show={true}
          disabled={props.shouldDisableFields}
          KeyText={"aademicDegreeName"}
          KeyValue={"academicDegreeId"}
          arrayOoptionList={state.DropDownAcademicDegree}
          dropdownType={"normal"}
          onChange={(e) => {
            setList({
              ...list,
              academicDegreeId: parseInt(e.target.value),
            });
          }}
          defaultValue={list?.academicDegreeId}
          showValidationMessage={validateacademicDegreeId}
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        <InputAHSF
          fieldsName="GraduationYear"
          show={true}
          type={"number"}
          disabled={props.shouldDisableFields}
          onChange={(e) => {
            setList({
              ...list,
              graduationYear: e.target.value,
            });
          }}
          defaultValue={list?.graduationYear}
          showValidationMessage={validategraduationYear}
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        <InputAHSF
          fieldsName="Specialization"
          show={true}
          disabled={props.shouldDisableFields}
          onChange={(e) => {
            setList({
              ...list,
              major: e.target.value,
            });
          }}
          defaultValue={list?.major}
          showValidationMessage={validatemajor}
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        <InputAHSF
          fieldsName="theUniversity"
          show={true}
          disabled={props.shouldDisableFields}
          onChange={(e) => {
            setList({
              ...list,
              university: e.target.value,
            });
          }}
          defaultValue={list?.university}
          showValidationMessage={validateuniversity}
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        <AllDropDownsAHSF
          fieldsName="Country"
          hidelable={false}
          labelName={"البلد"}
          show={true}
          disabled={props.shouldDisableFields}
          valueEdite={list?.nationalityId}
          submissionStatus={ props.canEdit?"edite":""}
          textEdite={ props.canEdit?list?.sU_ST_MRI_Nationality?.nationalityName:editText}
          arrayOoptionList={state.DropDownNationality}
          KeyText={"nationalityName"}
          id={"nationalityId"}
          dropdownType={"search"}
          defaultValue={list?.nationalityId}
          value={list?.nationalityId}
          OnClickLi={(e) => {
            setList({
              ...list,
              nationalityId: e.nationalityId,
            });
            setEditValue(e.nationalityId);
            setEditText(e.nationalityName);
            // setEditValue(e.yearId);
            // setEditText(e.yearName);
          }}
          showValidationMessage={validatenationalityId}
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        {/* <AllDropDownsAHSF
          fieldsName="Country"
          show={true}
          disabled={props.shouldDisableFields}
          KeyText={"nationalityName"}
          KeyValue={"nationalityId"}
          arrayOoptionList={state.DropDownNationality}
          dropdownType={"normal"}
          onChange={(e) => {
            setList({
              ...list,
              nationalityId: e.target.value,
            });
          }}
          defaultValue={list?.nationalityId}
          showValidationMessage={validatenationalityId}
          validationMessage="يرجى تعبئة هذا الحقل"
        /> */}
        {!props.shouldDisableFields ? (
          <div className="containersButton">
            <div>
              <ButtonAHSF
                type={"submitter"}
                onClick={() => {
                  props.canEdit == "edit" ? updateAcademic() : addAcademic();
                }}
                disabled={false}
                title={props.canEdit == "edit" ? "تعديل" : "اضافة"}
                text={props.canEdit == "edit" ? "تعديل" : "اضافة"}
                show={true}
              />
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  ) : (
    ""
  );
};

export default AddEditeAcademic;
